'use strict';

$(function () {
    var createApp = Vue.createApp;
    var ref = Vue.ref;
    var computed = Vue.computed;
    var onMounted = Vue.onMounted;

    createApp({
        setup: function setup() {
            var step = ref('phone'); 
            var phone = ref('');
            var pinDigits = ref(['', '', '', '', '', '']);
            var isLoading = ref(false);
            var message = ref({ text: '', type: 'error' });

            var getMemberApi = function getMemberApi() {
                return window.NextMovingMember || null;
            };

            var showMessage = function showMessage(text, type) {
                message.value = {
                    text: text || '',
                    type: type === 'success' ? 'success' : 'error'
                };
            };

            var formatPhoneInput = function formatPhoneInput(e) {
                var input = e.target.value.replace(/\D/g, '');
                if (input.length > 10) {
                    input = input.slice(0, 10);
                }
                var formatted = '';
                if (input.length > 0) {
                    formatted += '(' + input.slice(0, 3);
                }
                if (input.length > 3) {
                    formatted += ') ' + input.slice(3, 6);
                }
                if (input.length > 6) {
                    formatted += '-' + input.slice(6, 10);
                }
                phone.value = formatted;
            };

            var changePhone = function changePhone() {
                step.value = 'phone';
                showMessage('', 'error');
                pinDigits.value = ['', '', '', '', '', ''];
            };

            var handlePhoneSubmit = function handlePhoneSubmit() {
                var digits = phone.value.replace(/\D/g, '');
                if (digits.length !== 10) {
                    showMessage('Please enter a valid 10-digit phone number.', 'error');
                    return;
                }

                isLoading.value = true;
                showMessage('', 'error');

                $.ajax({
                    url: window.NEXT_MOVING_API_URL + '/phone-validations',
                    type: 'POST',
                    contentType: 'application/json',
                    data: JSON.stringify({
                        type: 'auth',
                        phone: phone.value
                    }),
                    success: function success(data) {
                        isLoading.value = false;
                        if (data && data.success === false) {
                            var _message = data.message ? 'We could not find customer with this phone number' : 'Verification failed. Please try again.';
                            showMessage(_message, 'error');
                        } else {
                            step.value = 'pin';
                            showMessage('Enter your 6-digit PIN for ' + phone.value + '.', 'success');
                            Vue.nextTick(function () {
                                var firstInput = document.querySelector('.js-pin-input-0');
                                if (firstInput) firstInput.focus();
                            });
                        }
                    },
                    error: function error(xhr) {
                        isLoading.value = false;
                        var errorMsg = 'Failed to send verification code. Please try again later.';
                        try {
                            var response = JSON.parse(xhr.responseText);
                            if (response && response.message) {
                                errorMsg = response.message;
                            }
                        } catch (e) {}
                        showMessage(errorMsg, 'error');
                    }
                });
            };

            var handlePinInput = function handlePinInput(index, e) {
                var val = e.target.value.replace(/\D/g, '').slice(0, 1);
                pinDigits.value[index] = val;

                if (val && index < 5) {
                    var nextInput = document.querySelector('.js-pin-input-' + (index + 1));
                    if (nextInput) nextInput.focus();
                }

                if (getPinValue().length === 6) {
                    handlePinSubmit();
                }
            };

            var handlePinKeyDown = function handlePinKeyDown(index, e) {
                if (e.key === 'Backspace' && !pinDigits.value[index] && index > 0) {
                    var prevInput = document.querySelector('.js-pin-input-' + (index - 1));
                    if (prevInput) {
                        prevInput.focus();
                        pinDigits.value[index - 1] = ''; 
                    }
                }
            };

            var handlePinPaste = function handlePinPaste(e) {
                var pasted = ((e.clipboardData || window.clipboardData).getData('text') || '').replace(/\D/g, '').slice(0, 6);
                if (!pasted) return;

                e.preventDefault();
                for (var i = 0; i < pasted.length; i++) {
                    if (i < 6) pinDigits.value[i] = pasted[i];
                }

                var focusIndex = Math.min(pasted.length, 5);
                var targetInput = document.querySelector('.js-pin-input-' + focusIndex);
                if (targetInput) targetInput.focus();

                if (pasted.length === 6) {
                    handlePinSubmit();
                }
            };

            var getPinValue = function getPinValue() {
                return pinDigits.value.join('');
            };

            var handlePinSubmit = function handlePinSubmit() {
                var code = getPinValue();
                if (code.length !== 6) {
                    showMessage('Please enter all 6 PIN digits.', 'error');
                    return;
                }

                isLoading.value = true;
                showMessage('', 'error');

                $.ajax({
                    url: window.NEXT_MOVING_API_URL + '/auth/customers/login',
                    type: 'POST',
                    contentType: 'application/json',
                    data: JSON.stringify({
                        code: code,
                        phone: phone.value
                    }),
                    success: function success(data) {
                        isLoading.value = false;
                        var token = data.access_token || '';

                        if (!token) {
                            showMessage('Invalid response from server. Missing token.', 'error');
                            return;
                        }

                        if (typeof window.removeCriticalData === 'function') {
                            window.removeCriticalData('nextMovingMemberOrders');
                        }
                        try {
                            localStorage.removeItem('nextMovingMemberOrders');
                            localStorage.removeItem('nextMovingMemberOrdersSeededV7');
                        } catch (e) {}

                        var session = {
                            phone: phone.value.replace(/\D/g, ''),
                            formattedPhone: phone.value,
                            token: token,
                            customer: data.customer || { name: 'My account' },
                            loggedInAt: new Date().toISOString()
                        };

                        var sessionStr = JSON.stringify(session);
                        if (typeof window.setCriticalData === 'function') {
                            window.setCriticalData('nextMovingMemberSession', sessionStr);
                        } else {
                            try {
                                localStorage.setItem('nextMovingMemberSession', sessionStr);
                            } catch (e) {}
                        }

                        window.dispatchEvent(new CustomEvent('nextmoving:auth-changed'));

                        showMessage('Signed in successfully. Redirecting...', 'success');
                        setTimeout(function () {
                            window.location.href = '/member-area';
                        }, 500);
                    },
                    error: function error(xhr) {
                        isLoading.value = false;
                        var errorMsg = 'Incorrect PIN code. Please try again.';
                        try {
                            var response = JSON.parse(xhr.responseText);
                            if (response && response.message) {
                                errorMsg = response.message;
                            }
                        } catch (e) {}
                        showMessage(errorMsg, 'error');
                        pinDigits.value = ['', '', '', '', '', ''];
                        var firstInput = document.querySelector('.js-pin-input-0');
                        if (firstInput) firstInput.focus();
                    }
                });
            };

            onMounted(function () {
                var member = getMemberApi();
                if (member) {
                    var session = member.getSession();
                    if (session && session.phone) {
                        window.location.href = '/member-area';
                    }
                }
            });

            return {
                step: step,
                phone: phone,
                pinDigits: pinDigits,
                isLoading: isLoading,
                message: message,
                formatPhoneInput: formatPhoneInput,
                changePhone: changePhone,
                handlePhoneSubmit: handlePhoneSubmit,
                handlePinInput: handlePinInput,
                handlePinKeyDown: handlePinKeyDown,
                handlePinPaste: handlePinPaste,
                handlePinSubmit: handlePinSubmit
            };
        }
    }).mount('#member-area-app');
});